import {
  getThreadCategoryTag,
  isThreadCategory,
  normalizeThreadCategoryNames,
  THREAD_CATEGORY_NAMES,
  type ThreadTag,
} from "@/entities/thread";
import { isR18ThreadTagName } from "@/shared/lib/threadTag";

const R18_FILTER_TAG = "R18";
const FILTER_TAG_NAMES: readonly string[] = [
  ...THREAD_CATEGORY_NAMES,
  R18_FILTER_TAG,
];

/** 投稿時の16分類とは別に、カタログではR18も絞り込み対象にする。 */
export function isCatalogFilterTag(name: string): boolean {
  return isThreadCategory(name) || name === R18_FILTER_TAG;
}

export function normalizeCatalogFilterTags(value: unknown): string[] {
  const categories: string[] = normalizeThreadCategoryNames(value);
  return Array.isArray(value) && value.includes(R18_FILTER_TAG)
    ? [...categories, R18_FILTER_TAG]
    : categories;
}

/** 現行分類は先頭の1件を採用し、R18固定タグは独立した対象として追加する。 */
export function getThreadFilterTagNames(tags: readonly ThreadTag[]): string[] {
  const category = getThreadCategoryTag(tags);
  const names: string[] = category ? [category.name] : [];
  if (
    tags.some((tag) => tag.kind === "fixed" && isR18ThreadTagName(tag.name))
  ) {
    names.push(R18_FILTER_TAG);
  }
  return names;
}

type TagFilterGroups = {
  categoryTags: string[];
  unavailableHiddenTags: string[];
};

/** 現行分類とR18を、一覧に存在するものだけ固定順でまとめる。 */
export function getTagFilterGroups(
  tagGroups: readonly (readonly ThreadTag[])[],
  hiddenTags: readonly string[],
): TagFilterGroups {
  const availableCategoryNames = new Set(
    tagGroups.flatMap(getThreadFilterTagNames),
  );
  return {
    categoryTags: FILTER_TAG_NAMES.filter((name) =>
      availableCategoryNames.has(name),
    ),
    unavailableHiddenTags: normalizeCatalogFilterTags(hiddenTags).filter(
      (name) => !availableCategoryNames.has(name),
    ),
  };
}
